import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalConfig';

/**
 * Create a single instance of PublicClientApplication to be shared across the app.
 * This should be created once and reused throughout the application lifecycle.
 *
 * Documentation: https://learn.microsoft.com/en-us/javascript/api/@azure/msal-browser/publicclientapplication
 */
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL instance (required before any MSAL API calls)
// This is a promise that must be awaited before using the instance
const initializeMsal = msalInstance.initialize();

export { msalInstance, initializeMsal };
export default msalInstance;
